import { hasPermission } from "../commons/Permissions/PermissionsHook";
export const checkSpecificPermission = (permissions, module, permission) =>
  hasPermission(permissions, module, permission);
